export enum authTypes {
  AUTH_IMPERSONATE = '[AUTH] Impersonating user',
  AUTH_LOGOUT = '[AUTH] User logged out',
  AUTH_SET_INITIAL_USER = '[AUTH] Set user initial info',
  AUTH_SET_TOKENS = '[AUTH] Refresh tokens',
  AUTH_UPDATE_USER_DATA = '[AUTH] Update user information',
  AUTH_UPDATE_USER_POINTS = '[AUTH] Update user points',
  AUTH_UPDATE_USER_COUPONS = '[AUTH] Update user coupons',
  AUTH_UPDATE_NEWSLETTER_SUBSCRIPTION = '[AUTH] Update user Newsletter subscription',
  AUTH_USER_LOGGED = '[AUTH] User logged in',
  AUTH_USER_DECLINED = '[AUTH] User declined',
  AUTH_RESET_USER_STATUS = '[AUTH] Reset User Status',
  AUTH_ACCOUNT_STATUS = '[AUTH] Set user account status',
  AUTH_ACCOUNT_SUBSCRIPTION = '[AUTH] Set user account subscription',
  AUTH_MC_SUBSCRIPTION = '[AUTH] Set user marketing cloud subscription',
  AUTH_PROFILE_COMPLETED = '[AUTH] Profile completed',
  AUTH_SET_PROFILING_BANNER_STATUS = '[AUTH] Set user profiling banner status',
  AUTH_SET_USER_STATUS = '[AUTH] Set user status',
  AUTH_SET_DERMO_ONBOARDING = '[AUTH] Set dermo onboarding',
  AUTH_SET_IS_DERMO_USER = '[AUTH] Set is dermo user',
  AUTH_SET_USER_SPECIALTY = '[AUTH] Set user specialty',
  AUTH_SET_USER_ROLE = '[AUTH] Set user role',
  AUTH_SET_TERMS_ACCEPTED = '[AUTH] Set user terms accepted',
}
